import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";

import { MapComponent } from "./map.component";
import { ZoomComponent } from "./controls/zoom.component";

@NgModule({
  declarations: [
    MapComponent,
    ZoomComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [
    MapComponent,
    ZoomComponent
  ]
})
export class MapsModule { }



// WEBPACK FOOTER //
// /app/SPA/src/app/core/maps/maps.module.ts